import moment from 'moment'

const getHoursWithMin = (time) => {
  const splittedTime = time.split(':')

  splittedTime.pop()
  return splittedTime.join(':')
}

export const getTimeRange = (startTime, endTime) => {
  return ` ( ${getHoursWithMin(startTime)} - ${getHoursWithMin(endTime)} ) `
}
export const getDateRange = (startDate, endDate) => {
  return `${moment(startDate).format('DD.MM')} - ${moment(endDate).format(
    'DD.MM'
  )}`
}
